<template>
  <div class="shark-container shark-container--one" v-if="enabled">
    <div class="shark shark--one"></div>
  </div>
</template>

<script>
import EChart from "@/components/chart/echart";

export default {
  components: {
    EChart,
  },
  props: {
    enabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },

  computed: {
    computeCardDark() {
      return this.cardColor !== "white";
    },
  },
};
</script>

<style scoped>
*,
*::before,
*::after {
  box-sizing: border-box;
}

.shark {
  background-image: url("~/img/swimming-shark.svg");
  background-size: auto 100%;
  width: 110px;
  height: 125px;
  will-change: background-position;
  -webkit-animation-timing-function: steps(10);
  animation-timing-function: steps(10);
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
.shark--one {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-delay: -0.5s;
  animation-delay: -0.5s;
}

.shark-container {
  z-index: 9999;
  position: absolute;
  top: 1%;
  left: -10%;
  -webkit-transform: scale(0) translateX(-20vw);
  transform: scale(0) translateX(-20vw);
  will-change: transform;
  -webkit-animation-name: swim-right-one;
  animation-name: swim-right-one;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-iteration-count: 3;
  animation-iteration-count: 3;
}
.shark-container--one {
  -webkit-animation-duration: 15s;
  animation-duration: 15s;
  -webkit-animation-delay: 10s;
  animation-delay: 10s;
}

@-webkit-keyframes swim-cycle {
  100% {
    background-position: -900px 0;
  }
}

@keyframes swim-cycle {
  100% {
    background-position: -900px 0;
  }
}
@-webkit-keyframes swim-right-one {
  0% {
    -webkit-transform: scale(0.3) translateX(-10vw);
    transform: scale(0.3) translateX(-10vw);
  }
  10% {
    -webkit-transform: translateY(2vh) translateX(10vw) scale(0.4);
    transform: translateY(2vh) translateX(10vw) scale(0.4);
  }
  20% {
    -webkit-transform: translateY(0vh) translateX(30vw) scale(0.5);
    transform: translateY(0vh) translateX(30vw) scale(0.5);
  }
  30% {
    -webkit-transform: translateY(4vh) translateX(50vw) scale(0.6);
    transform: translateY(4vh) translateX(50vw) scale(0.6);
  }
  40% {
    -webkit-transform: translateY(2vh) translateX(70vw) scale(0.6);
    transform: translateY(2vh) translateX(70vw) scale(0.6);
  }
  50% {
    -webkit-transform: translateY(0vh) translateX(90vw) scale(0.6);
    transform: translateY(0vh) translateX(90vw) scale(0.6);
  }
  60% {
    -webkit-transform: translateY(0vh) translateX(110vw) scale(0.6);
    transform: translateY(0vh) translateX(110vw) scale(0.6);
  }
  100% {
    -webkit-transform: translateY(0vh) translateX(110vw) scale(0.6);
    transform: translateY(0vh) translateX(110vw) scale(0.6);
  }
}
@keyframes swim-right-one {
  0% {
    -webkit-transform: scale(0.3) translateX(-10vw);
    transform: scale(0.3) translateX(-10vw);
  }
  10% {
    -webkit-transform: translateY(2vh) translateX(10vw) scale(0.4);
    transform: translateY(2vh) translateX(10vw) scale(0.4);
  }
  20% {
    -webkit-transform: translateY(0vh) translateX(30vw) scale(0.5);
    transform: translateY(0vh) translateX(30vw) scale(0.5);
  }
  30% {
    -webkit-transform: translateY(4vh) translateX(50vw) scale(0.6);
    transform: translateY(4vh) translateX(50vw) scale(0.6);
  }
  40% {
    -webkit-transform: translateY(2vh) translateX(70vw) scale(0.6);
    transform: translateY(2vh) translateX(70vw) scale(0.6);
  }
  50% {
    -webkit-transform: translateY(0vh) translateX(90vw) scale(0.6);
    transform: translateY(0vh) translateX(90vw) scale(0.6);
  }
  60% {
    -webkit-transform: translateY(0vh) translateX(110vw) scale(0.6);
    transform: translateY(0vh) translateX(110vw) scale(0.6);
  }
  100% {
    -webkit-transform: translateY(0vh) translateX(110vw) scale(0.6);
    transform: translateY(0vh) translateX(110vw) scale(0.6);
  }
}
</style>
